import React, { useState } from "react"
import { Routes, Route } from 'react-router-dom'
import Sidebar from "./Sidebar"
import UsersPage from "./UsersPage"
import ContentPage from "../../pages/Home/HomeContentEditor"
import ProfilePage from "./ProfilePage"
import DashboardPage from "./DashboardPage"
import ReportsManagement from "./ReportsManagement"
import AreasManagement from "./AreasManagement"
import TiffManagement from "./TiffManagement"
import UserProfilePage from "./UserProfilePage"
import IndexManagement from "./IndexManagement"
import "./AdminDashboard.css"

const AdminDashboard = () => {
  const [activePage, setActivePage] = useState("dashboard")

  return (
    <div className="admin-dashboard">
      <Sidebar setActivePage={setActivePage} activePage={activePage} />
      <div className="dashboard-content">
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="users/:userId" element={<UserProfilePage />} />
          <Route path="content" element={<ContentPage />} />
          {/* <Route path="profile" element={<ProfilePage />} /> */}
          <Route path="reports" element={<ReportsManagement />} />
          <Route path="areas" element={<AreasManagement />} />
          <Route path="tifs" element={<TiffManagement />} />
          <Route path="indexes" element={<IndexManagement />} />
        </Routes>
      </div>
    </div>
  )
}

export default AdminDashboard
